module.exports = __webpack_public_path__ + "static/media/header-reno_elements.0e17d434.png";